// const BASEURL = "http://192.168.1.42:8092/";
//  const BASEURL = 'https://abdmapi.lalpathlabs.com/';
const BASEURL = "https://abdm-api.pathkindlabs.com/";
// const BASEURL = "http://localhost:8092/";
// const BASEURL = "https://abdm.abym.us/";
//const BASEURL = 'https://uat-abdmapi.lalpathlabs.com/';
const API_URL = {
  BASEURL: BASEURL,
  API_BASEURL: `${BASEURL}api/v1/`,
  IMAGE_URL: BASEURL,

  LOGIN_AUTH: `auth/get-time`,
  LOGIN: `auth/signin`,
  DASHBOARD_FAQ_COUNT: `/dashboard/faqs/count`,
  DASHBOARD_USER_COUNT: `/dashboard/users/count`,
  DASHBOARD_JOB_ADD_COUNT: `/dashboard/jobs/count`,
  USER_LIST: `/users/list`,
  USER_ADD: `/users/add`,
  USER_UPDATE: `/users/update`,
  USER_STATUS_UPDATE: `/users/update/status`,
  UPDATE_PASSWORD: `/users/changepassword`,
  USER_BY_ID: `/users/details`,
  ROLE_LIST: `/role/list`,
  ROLE_ADD: `/role/add`,
  ROLE_UPDATE: `/role/update`,
  ROLE_BY_ID: `/role/details`,
  FILTER_DATA: "/role/filterdata",
  PERMISSION_UPDATE: "/role/updatepermissions",
  ABHA_CREATED_LIST: `admin/getCardLogs`,
  ABHA_LINK_NOTIFY: `hip/v2/link-record`,
  ABDM_UPLOAD_FILE: `s3/upload/file`,
  ABDM_HIP_AUTH_LIST: `hip/list/auth-confirm-logs`,
  PATIENT_ABHA_LIST: `abha/patientAbhaCardsLogs`,
  PATIENT_REPORT_LIST: `/hip/list/patient-report`,
  HEALTH_INFORMATION_REQUEST: `hiu/health-information-request`,
  DOWNLOAD_REPORT: `hiu/data-decryption`,
  DECODE_BASE64: `upload/base64ToPdf`,
  UPLOADREPORT: `/abha/add/patient-reports`,
  GET_REPORT_PDF: `/users/downloadReportPdf`,
  LOG_OUT: "/users/signout",
  AUDIT_LOGS: "/admin/getAbhaLogs"
};
export default API_URL;
